# GraphQL mutation to delete a slack automation

mutation DeleteOpenLeadSlackMessage(
    $openLeadSlackMessage: DeleteOpenLeadSlackMessageInputFieldInput!
) {
    deleteOpenLeadSlackMessage(input: {openLeadSlackMessage: $openLeadSlackMessage}) {
        openLeadSlackMessage {
            id
        }
    }
}
